import { ReactNode } from "react";
import { useAuth } from "../services/auth";
import { UnauthorizedPage } from "../pages/admin/UnauthorizedPage";
import { LoadingState } from "./LoadingState";

export function AdminRoute({
  permission,
  children
}: {
  permission?: string;
  children: ReactNode;
}) {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingState label="Checking newsroom clearance..." />;
  }

  if (!user) {
    return <UnauthorizedPage title="Authentication Required" message="Please log in with your editorial credentials to proceed." />;
  }

  // Super Admin wildcard check or role check
  const isSuperAdmin =
    user.permissions.includes("*") ||
    user.roles.some((r) => ["Super Administrator", "Administrator", "admin"].includes(r));

  if (isSuperAdmin) {
    return <>{children}</>;
  }

  if (permission && !user.permissions.includes(permission)) {
    return (
      <UnauthorizedPage
        requiredPermission={permission}
        title="Unauthorized Access"
        message={`Your staff role does not have authorization to access the [${permission}] workflow. Please contact an Administrator if you believe this is an error.`}
      />
    );
  }

  return <>{children}</>;
}
